export default {
  GET_ALL_ACTIONSETS: 'getAllActionsets',
  SAVE_ACTIONSET: 'saveActionset',
  UPDATE_ACTIONSET: 'updateActionset',
  GET_ACTIONSETS_BY_NODE: 'getActionsetsByNode',
  ADD_ACTIONSET_NODE_RELATIONSHIP: 'addActionsetNodeRelationship',
  REMOVE_ACTIONSET_NODE_RELATIONSHIP: 'removeActionsetNodeRelationship'
}
